import React, { useState } from 'react';
import { Alert, Button, Drawer, Table } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import OrderDetail from './OrderDetail';

const OrderActionReceipt = ({ receipt, onDismiss, compact = false }) => {
  const [open, setOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const hasResponse = receipt.outcome === 'received';
  return (
    <>
      <div
        className={'order-receipt' + (compact ? ' order-receipt-compact' : '')}
      >
        {!compact && (
          <div className="order-receipt-summary" role="status">
            <span>
              {hasResponse
                ? `已提交 ${receipt.orders.length} 笔`
                : `${receipt.orders.length} 笔订单结果暂未确认`}
            </span>
            <small className="muted">
              {hasResponse ? '订单状态待核对' : '核对后再决定是否重试'}
            </small>
          </div>
        )}
        <Button type="link" size="small" onClick={() => setOpen(true)}>
          {compact ? '上次提交待核对' : '核对订单'}
        </Button>
        {!compact && (
          <Button
            type="text"
            size="small"
            icon={<CloseOutlined />}
            aria-label="收起提交记录"
            onClick={onDismiss}
          />
        )}
      </div>
      <Drawer
        title="本次处理记录"
        aria-label="本次处理记录"
        width="min(620px, 100vw)"
        open={open}
        onClose={() => setOpen(false)}
      >
        <Alert
          type={hasResponse ? 'info' : 'warning'}
          showIcon
          message={
            hasResponse
              ? `已提交 ${receipt.orders.length} 笔，订单状态待核对`
              : '结果尚未确认，请先核对再决定是否重试'
          }
          description={
            receipt.error ||
            '下方保留本次提交的订单。点击订单号查看当前状态，实际扣费请核对积分明细。'
          }
        />
        <dl className="batch-summary receipt-summary">
          <dt>提交时间</dt>
          <dd>
            {new Date(receipt.submittedAt).toLocaleString('zh-CN', {
              hour12: false,
            })}
          </dd>
          <dt>提交订单</dt>
          <dd>{receipt.orders.length} 笔</dd>
          <dt>跳过其他状态</dt>
          <dd>{receipt.skippedCount} 笔</dd>
          <dt>提交时预计消耗</dt>
          <dd>{receipt.expectedPoints} 积分</dd>
        </dl>
        <Table
          rowKey="id"
          size="small"
          dataSource={receipt.orders}
          pagination={{
            pageSize: 10,
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
          columns={[
            {
              title: '已提交订单 / 店铺',
              key: 'order',
              render: (_, order) => (
                <div>
                  <Button
                    type="link"
                    className="receipt-order-link"
                    onClick={() => setSelectedOrder(order)}
                  >
                    {order.orderNo || '订单 ' + order.id}
                  </Button>
                  <div className="muted">{order.storeName || '未填写店铺'}</div>
                </div>
              ),
            },
          ]}
        />
        <p className="muted receipt-note">
          此记录保留至页面刷新。需要对账时，请在积分明细中查询对应订单。
        </p>
        <Link to="/app/points">前往积分明细</Link>
      </Drawer>
      <OrderDetail
        visible={Boolean(selectedOrder)}
        order={selectedOrder}
        onClose={() => setSelectedOrder(null)}
      />
    </>
  );
};
export default OrderActionReceipt;
